import { GET_WEBINARS } from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import { WebinarData, WebinarsData } from './types'

class WebinarsServiceClass extends AbstractService {
  fetchWebinars = () => this.request<ServerResponse<WebinarsData>>(GET_WEBINARS, 'get', true)
  fetchWebinarById = (id: number) =>
    this.request<ServerResponse<WebinarData>>(`${GET_WEBINARS}/${id}`, 'get', true)
}

export const WebinarsService = new WebinarsServiceClass()
